import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

import { productImageHeightDesktop } from '../../../constants';
import { IconButton } from '@prisjakt/ui/button/variants';

const padding = '10px';
const buttonsTopVal = productImageHeightDesktop;

export const ButtonsWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  top: ${buttonsTopVal}px;
`;

export const ChevronButtons = styled.div`
  position: absolute;
  top: ${buttonsTopVal}px;
  z-index: 3;
  pointer-events: none;
  width: 100%;

  @supports (position: sticky) {
    position: sticky;
  }
`;

type ButtonProps = {
  hidden: boolean;
  left?: boolean;
  right?: boolean;
};

export const Button = styled(IconButton)<ButtonProps>`
  position: absolute;
  background-color: ${p => p.theme.buttons.panning.bg};
  color: ${p => p.theme.buttons.panning.text};
  pointer-events: all;
  opacity: 1;
  transition: opacity 0.2s;
  transform: translateY(-100%);
  border-radius: 100%;


  && {
    svg {
      path {
        fill: ${p => p.theme.buttons.panning.text};
      }
    }
  }

  &&:hover,
  &&:focus {
    background: ${p => p.theme.buttons.panning.bgHover};
  }

  ${props =>
    props.hidden &&
    css`
      opacity: 0;
    `}

  ${props =>
    props.left &&
    css`
      left: ${padding};
      margin-left: ${layout.measurements.spacing100};
    `}

    ${props =>
      props.right &&
      css`
        right: ${padding};
        margin-right: ${layout.measurements.spacing100};
      `}
`;
